import {useQuery} from 'react-query'
import {getProjectTemplatesList} from '../core/_requests'

export type ProjectTemplatesListPayload = {
  items: any[]
  pagination: {
    current_page: number
    per_page: number
    total: number
    last_page: number
    from: number | null
    to: number | null
    links?: Array<{label: string; active: boolean; url: string | null}>
  }
}

const emptyPagination: ProjectTemplatesListPayload['pagination'] = {
  current_page: 1,
  per_page: 10,
  total: 0,
  last_page: 1,
  from: null,
  to: null,
  links: [],
}

/** Lista paginada (modelos de projeto), mesma forma que modelos de cronograma. */
export function useGetProjectTemplates(page: number, search?: string) {
  const safePage = Math.max(1, Math.floor(page) || 1)
  const safeSearch = (search ?? '').trim()

  return useQuery(
    ['project-templates-list', safePage, safeSearch],
    async (): Promise<ProjectTemplatesListPayload> => {
      const body = await getProjectTemplatesList(safePage, undefined, safeSearch)
      const rawPagination = body?.payload?.pagination ?? {}
      return {
        items: Array.isArray(body?.data) ? body.data : [],
        pagination: {
          ...emptyPagination,
          ...rawPagination,
          links: Array.isArray(rawPagination.links) ? rawPagination.links : [],
        },
      }
    },
    {
      cacheTime: 0,
      keepPreviousData: true,
      refetchOnWindowFocus: true,
    }
  )
}

/** Primeira página com muitos itens (ex.: select no modal de novo projeto). */
export function useGetProjectTemplatesBootstrap(perPage = 200, enabled = true) {
  return useQuery(
    ['project-templates-list', 'bootstrap', perPage],
    async () => {
      const body = await getProjectTemplatesList(1, perPage)
      return Array.isArray(body?.data) ? body.data : []
    },
    {
      enabled,
      cacheTime: 0,
      keepPreviousData: false,
      refetchOnWindowFocus: false,
    }
  )
}
